import Full from './Full';

export default Full;
